// extracted by mini-css-extract-plugin
export default {"logo-white":"logo-white--El7wB","logoWhite":"logo-white--El7wB","logo-dark":"logo-dark--UX2dd","logoDark":"logo-dark--UX2dd"};